
import { Vue, Component } from 'vue-property-decorator'
import MainLayout from '@/layout/main/MainLayout.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

@Component({
  name: 'App',
  components: { MainLayout },
})
export default class App extends Vue {
  private location = location
  private locale = zhCN
}
